import { ToolKitTourSteps } from './steps';
import { Tour } from 'antd';
import { useLocalStorageState } from '../../../lib/hooks';
const ToolkitsSideMenuTour = () => {
  const [completed, setCompleted] = useLocalStorageState('sidemenu-tour-completed', false);
  return <Tour open={!completed} onClose={() => setCompleted(true)} steps={ToolKitTourSteps} disabledInteraction={true} data-sentry-element="Tour" data-sentry-component="ToolkitsSideMenuTour" data-sentry-source-file="index.jsx" />;
};
export default ToolkitsSideMenuTour;